import { render, staticRenderFns } from "./subcategories.vue?vue&type=template&id=5b57e1e2"
import script from "./subcategories.vue?vue&type=script&lang=js"
export * from "./subcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports